import { Modal } from "react-bootstrap";

/**
 * A product's workflow history (user, 2026-11-02): every Done / Undo at a
 * station, newest first. Entries are never replaced, only added.
 *
 * history   [{ nodeId, stationId, label, action, userName, at }]
 * stations  Map stationId -> { name }
 */
export const stationText = (entry, stations) => {
  const name = stations?.get(Number(entry.stationId))?.name || "Station removed";
  return entry.label ? `${name} (${entry.label})` : name;
};

export const whenText = (at) =>
  at
    ? new Date(at).toLocaleString([], {
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "";

export default function WorkflowHistoryModal({ show, onHide, title, history = [], stations }) {
  const rows = [...history].reverse();
  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable contentClassName="border border-2 shadow-lg">
      <Modal.Header closeButton>
        <Modal.Title>{title || "Workflow History"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!rows.length ? (
          <div className="text-muted">Nothing done yet.</div>
        ) : (
          <table className="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th>Station</th>
                <th>Action</th>
                <th>By</th>
                <th>When</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((h, i) => (
                <tr key={`${h.at}-${i}`}>
                  <td>{stationText(h, stations)}</td>
                  <td>
                    {h.action === "done" ? (
                      <span className="badge bg-success">Done</span>
                    ) : (
                      <span className="badge bg-secondary">Undo</span>
                    )}
                  </td>
                  <td>{h.userName || "-"}</td>
                  <td className="text-nowrap">{whenText(h.at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
}
